module.exports = __webpack_public_path__ + "img/xiao.113ca58b.png";